export default __webpack_public_path__ + "static/media/two.603585b7.png";